import { render, staticRenderFns } from "./BaseMultiInput.vue?vue&type=template&id=d959960c"
import script from "./BaseMultiInput.vue?vue&type=script&lang=js"
export * from "./BaseMultiInput.vue?vue&type=script&lang=js"
import style0 from "./BaseMultiInput.vue?vue&type=style&index=0&id=d959960c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports